<template>
  <!-- MDK-6: ortak DataTable'ı kullanmayan listelerin dar ekran kart görünümü (DataTable.vue M1-4
       kartıyla aynı görünüm): solda başlık + özet alanlar (varsayılan yuva), sağda işlem düğmeleri
       (#islem yuvası), 20'şer «Daha fazla göster». -->
  <div class="w-full flex flex-col gap-3">
    <div v-if="!satirlar.length" class="py-6 text-center text-sm text-gray-500 dark:text-gray-400">
      {{ yukleniyor ? "Yükleniyor…" : bosMetin }}
    </div>
    <div
      v-for="(satir, i) in satirlar.slice(0, adet)"
      :key="anahtar ? satir[anahtar] : i"
      class="rounded-xl border border-surface-200 dark:border-surface-700 bg-surface-0 dark:bg-surface-900 p-3 flex items-center gap-3"
    >
      <div class="flex-1 min-w-0 flex flex-col gap-1">
        <slot :satir="satir" />
      </div>
      <div v-if="$slots.islem" class="flex flex-col gap-2 shrink-0">
        <slot name="islem" :satir="satir" />
      </div>
    </div>
    <Button
      v-if="satirlar.length > adet"
      severity="secondary"
      outlined
      class="min-h-[44px]"
      @click="adet += 20"
    >Daha fazla göster ({{ satirlar.length - adet }})</Button>
  </div>
</template>

<script>
export default {
  name: "KartListesi",
  props: {
    satirlar: { type: Array, default: () => [] },
    anahtar: { type: String, default: "" },
    bosMetin: { type: String, default: "Kayıt bulunamadı." },
    yukleniyor: { type: Boolean, default: false },
  },
  data() {
    return { adet: 20 };
  },
  watch: {
    satirlar() {
      this.adet = 20;
    },
  },
};
</script>
